import Swiper, {EffectFade, HashNavigation, Keyboard, Mousewheel, Navigation, Pagination, Thumbs} from "swiper";
import lozad from "lozad";
import {getHalfViewPortHeight} from "../components/helpers";
import tr from "air-datepicker/locale/tr";


export function initGalleryPage() {
    const $galleryList = $('#gallery_list');

    if (!$galleryList.length) {
        return;
    }

    const observer = lozad('.lozad', {
        rootMargin: `${getHalfViewPortHeight()}px 0px`,
    });

    observer.observe();

    $galleryList.on('click', '.gallery-item', (e) => {
        const $item = $(e.currentTarget);
        handlerImageClick($item);
    });

    const headingText = $galleryList.attr('data-heading') || '';

    $('body').on('click', '#close_gallery_swiper', () => {
        hideModal();
    });

    $('body').append(renderGalleryModal())

    appendSlides();

    const photoHash = window.location.hash;
    const photoNumber = photoHash.split('_')[1];

    if (photoNumber >= 0) {
        setTimeout(() => {
            showModal();
            slider.slideTo(+photoNumber - 1, 300)
        }, 150)
    }

    const {
        slider,
        thumbSlider
    } = initSliders();

    const mobile = window.matchMedia('(max-width: 1327px)');

    refreshSwiper(mobile);

    $(window).on('resize', () => {
        refreshSwiper(mobile)
    })

    function refreshSwiper(mobile) {
        if (mobile.matches) {
            thumbSlider.changeDirection('horizontal')
        } else {
            thumbSlider.changeDirection('vertical')
        }
    }

    $('body').on('keyup', (e) => {
        const code = +e.keyCode;
        const slidesLength = $('.gallery-slider .swiper-slide').length;

        if ($('.gallery-slider:visible').length && [35, 36].includes(code)) {
            if (code === 36) {
                slider.slideTo(0)
            }


            if (code === 35) {
                slider.slideTo(slidesLength)
            }
        }
    })

    function handlerImageClick(item) {
        const index = item.attr('data-index') || 0;
        //window.location.hash = `photo_${+index + 1}`;
        // slider.slideTo(index, 300)
        showModal();
        // window.location.hash = `photo_${+index + 1}`;
        slider.slideTo(+index, 0)
        //
        // $(`[data-hash="photo_${+index + 1}"]`).trigger('click');
    }

    function appendSlides() {
        let result = ''
        let bigPhotosSlides = ''
        let previewPhotosSlides = ''

        $.each($galleryList.find('.gallery-item'), (key, val) => {
            const $item = $(val);
            const $index = $item.attr('data-index');
            const dataBackgroundImage = $item.attr('data-background-image');
            let settings = $item.attr('data-settings') || '';

            if (settings.length) {
                settings = JSON.parse(settings);
                settings.preview = dataBackgroundImage
                bigPhotosSlides += getSlideItemHTML(settings, $index);
                previewPhotosSlides += getSlideItemHTML(settings, $index, 'preview');
            }
        });

        $('.gallery-slider .swiper-wrapper').html(bigPhotosSlides);
        $('.thumbs-for-gallery-slider .swiper-wrapper').html(previewPhotosSlides);

        observer.observe();

        function getSlideItemHTML(settings, index, type) {
            const {
                description = '',
                match = {},
                photo = '',
                preview = '',
                photoOrig = '',
                players = [],
                tags = [],
            } = settings;

            let playersHTML = '';

            let tempPhoto = photo;

            if (type === 'preview') {
                tempPhoto = preview
            }

            if (players.length) {
                $.each(players, (key, val) => {
                    const player = players[key];
                    const {
                        name = '',
                        url = ''
                    } = player;

                    if (url) {
                        playersHTML += `<a href="${url}" class="link">${name}</a>`;
                    }
                })

                if (playersHTML.length) {
                    playersHTML = `<div class="na-photo">На фото: ${playersHTML}</div>`;
                }
            }

            let descriptionHTML = '';

            if (description.length) {
                descriptionHTML = `<div class="description">${description}</div>`
            }

            let matchHTML = '';

            if (match) {
                if (match.url) {
                    matchHTML = `<div class="na-photo">Матч: <a href="${match.url}">${match.name}</a></div>`;
                }
            }

            let tagsHTML = '';

            if (tags.length) {
                $.each(tags, (key, val) => {
                    const $item = tags[key];
                    tagsHTML += getTagHTML($item)
                })
            }

            if (tagsHTML.length) {
                tagsHTML = `<div class="tags">${tagsHTML}</div>`
            }

            let downloadHTML = ` <a href="${photoOrig}" target="_blank" download class="download-link"> 
                            <span class="icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.4032 13.5341C8.48155 13.6125 8.57457 13.6746 8.67694 13.717C8.77931 13.7594 8.88903 13.7812 8.99984 13.7812C9.11065 13.7812 9.22037 13.7594 9.32274 13.717C9.42511 13.6746 9.51813 13.6125 9.59648 13.5341L12.7784 10.3521C12.9367 10.1939 13.0256 9.9793 13.0256 9.75553C13.0256 9.53175 12.9367 9.31714 12.7784 9.15891C12.6202 9.00067 12.4056 8.91178 12.1818 8.91178C11.958 8.91178 11.7434 9.00067 11.5852 9.15891L9.84359 10.9005V1.6875C9.84359 1.46372 9.7547 1.24911 9.59646 1.09088C9.43823 0.932645 9.22362 0.84375 8.99984 0.84375C8.77606 0.84375 8.56145 0.932645 8.40322 1.09088C8.24499 1.24911 8.15609 1.46372 8.15609 1.6875V10.9005L6.41449 9.15891C6.25625 9.00067 6.04164 8.91178 5.81787 8.91178C5.59409 8.91178 5.37948 9.00067 5.22125 9.15891C5.06302 9.31714 4.97412 9.53175 4.97412 9.75553C4.97412 9.9793 5.06302 10.1939 5.22125 10.3521L8.4032 13.5341Z" fill="#2556B4"/>
                                <path d="M16.3125 8.15625C16.0887 8.15625 15.8741 8.24514 15.7159 8.40338C15.5576 8.56161 15.4688 8.77622 15.4688 9V15.4688H2.53125V9C2.53125 8.77622 2.44236 8.56161 2.28412 8.40338C2.12589 8.24514 1.91128 8.15625 1.6875 8.15625C1.46372 8.15625 1.24911 8.24514 1.09088 8.40338C0.932645 8.56161 0.84375 8.77622 0.84375 9V15.75C0.84375 16.123 0.991908 16.4806 1.25563 16.7444C1.51935 17.0081 1.87704 17.1562 2.25 17.1562H15.75C16.123 17.1562 16.4806 17.0081 16.7444 16.7444C17.0081 16.4806 17.1562 16.123 17.1562 15.75V9C17.1562 8.77622 17.0674 8.56161 16.9091 8.40338C16.7509 8.24514 16.5363 8.15625 16.3125 8.15625Z" fill="#2556B4"/>
                                </svg>
                            </span> 
                            Скачать</a>`;

            return `<div class="swiper-slide" data-hash="photo_${+index + 1}">
                <div class="item lozad" data-background-image="${tempPhoto}">
                  
                </div>
                 <div class="tags-wrapper hide-mobile">
                    ${tagsHTML}
                 </div>   
                 <div class="bottom-info hide-mobile">
                        ${descriptionHTML}
                        ${playersHTML}
                        ${matchHTML}
                        ${downloadHTML}
                </div>
                <div class="bottom-info hide-desktop">
                    ${descriptionHTML}
                    ${tagsHTML}
                    ${playersHTML}
                    ${matchHTML}
                    ${downloadHTML}
                </div>
            </div>`

            function getTagHTML(tag) {
                if (!tag) return;

                const {
                    name = '',
                    url = ''
                } = tag;

                if (url) {
                    return `<a href="${url}" class="tag">${name}</a>`
                } else {
                    return `<div class="tag">${name}</div>`
                }
            }
        }
    }

    function initSliders() {
        const $thumbSwiper = new Swiper('.thumbs-for-gallery-slider', {
            speed: 300,
            watchSlidesProgress: true,
            watchOverflow: true,
            autoHeight: true,
            observeParents: true,
            observeSlideChildren: true,
            observer: true,
            breakpoints: {
                320: {
                    spaceBetween: 5,
                    slidesPerView: 5
                },
                1000: {
                    slidesPerView: 6,
                    spaceBetween: 6,
                },
                1024: {
                    slidesPerView: 8,
                    spaceBetween: 6,
                },
                1326: {
                    slidesPerView: 8,
                    spaceBetween: 8,
                },
                1327: {
                    slidesPerView: 8,
                    spaceBetween: 6,
                }
            }
        });

        const $gallerySwiper = new Swiper('.gallery-slider', {
            speed: 300,
            modules: [Navigation, Pagination, Thumbs, Keyboard, Mousewheel, HashNavigation],
            slideToClickedSlide: true,
            // effect: 'fade',
            observer: true,
            watchOverflow: true,
            observeParents: true,
            observeSlideChildren: true,
            height: 'auto',
            keyboard: {
              enabled: true,
                onlyInViewport: true
            },
            mousewheel: {
                invert: false,
                eventsTarget: '.gallery-slider',
                thresholdDelta: 5
            },
            hashNavigation: {
                replaceState: false,
                watchState: true
            },
            on: {
              hashChange: function (swiper) {
                if (window.location.hash === '') {
                    hideModal();
                } else {
                    showModal()
                }
              },
            },
            pagination: {
                el: '.gallery-slider-pagination.swiper-pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    return `${headingText} (&nbsp;${current}&nbsp;из&nbsp;${total}&nbsp;)`;
                }
            },
            thumbs: {
                swiper: $thumbSwiper,
            },
            breakpoints: {
                320: {
                    spaceBetween: 15,
                },
            },
            navigation: {
                nextEl: '.gallery-slider .swiper-button-next',
                prevEl: '.gallery-slider .swiper-button-prev'
            },
        });

        return {
            thumbSlider: $thumbSwiper,
            slider: $gallerySwiper
        }
    }

    function showModal() {
        $('html').css('overflow', 'hidden');
        $('#gallery_modal').show();
    }

    function hideModal() {
        $('html').css('overflow', 'auto');
        $('#gallery_modal').hide();
        window.location.hash = '';
    }

    function renderGalleryModal() {
        return `<div class="modal-window" id="gallery_modal">
                            <div class="modal-content crazy-vh">
                                <div class="section transparent no-padding">
                                    <div class="container">
                                        <div class="another-wrapper">
                                            <div class="heading-block">
                                                <div class="gallery-slider-pagination swiper-pagination"></div>
                                                <div class="close" id="close_gallery_swiper">
                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M17 1L1 17M1 1L17 17" stroke="white" stroke-width="2" stroke-linecap="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="swiper gallery-slider">
                                                <div class="swiper-wrapper">
                                                
                                                </div>
                                                <div class="swiper-button-next"></div>
                                                <div class="swiper-button-prev"></div>
                                            </div>
                                            <div class="swiper thumbs-for-gallery-slider">
                                                 <div class="swiper-wrapper">
                                                 
                                                 </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pxl"></div>
                        </div>`;
    }
}
